import { Injectable, Inject, DOCUMENT } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class GtmService {
  constructor(@Inject(DOCUMENT) private readonly document: Document) { }

  loadGtm(gtmId: string): void {
    if (!gtmId) return;

    if (this.document.getElementById('gtm-script')) return;

    const script = this.document.createElement('script');
    script.id = 'gtm-script';
    script.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${gtmId}');
    `;
    this.document.head.appendChild(script);

    const noscript = this.document.createElement('noscript');
    noscript.innerHTML = `
      <iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}"
        height="0" width="0" style="display:none;visibility:hidden"></iframe>
    `;
    this.document.body.insertBefore(noscript, this.document.body.firstChild);
  }
}
